const documents = [
  {
    label: "Letter of Introduction form Employee's HR",
    value: "introduction_letter",
  },
  {
    label: "Past 3 Month’s payslip",
    value: "pay_slip",
  },
  {
    label:
      "Valid Means of Identification (Int’l Passport, NIN Slip, Drivers License or Voter’s Card)",
    value: "identification",
  },
  {
    label: "12 months Bank statement",
    value: "salary_account",
  },
  {
    label: "Valid Offer Letter from Seller",
    value: "seller_offer_letter",
  },
  {
    label: "Evidence of requisite Equity Contribution",
    value: "equity_contribution_evidence",
  },
  {
    label: "Copy of Title Documents to the property",
    value: "property_title_document",
  },
  {
    label: "Search report from Bank Approved Lawyer",
    value: "lawyer_search_reports",
  },
  {
    label: "Valuation report from a Bank Approved Valuer",
    value: "valuation_reports",
  },
  // {
  //   label: "Fees for Property Search, verification and valuation",
  //   value: "property_fees",
  // },
  {
    label: "Spousal Consent Letter (FOR JOINT APPLICATION)",
    value: "spousal_consent",
  },
  {
    label: "Company Profile",
    value: "company_profile",
  },
  {
    label: "2 years Audited Financial reports",
    value: "financial_reports",
  },
  {
    label: "Cashflow Projections",
    value: "cashflow_projections",
  },
  {
    label: "From CO2  or CO7",
    value: "co2_co7",
  },
  {
    label: "Certificate of registration/ Incorporation		",
    value: "registration_certificate",
  },
  // {
  //   label: "Account Statement for the past 12 months",
  //   value: "registration_certificate",
  // },
];

export default documents;
